// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as EquipeRouteImport } from './routes/equipe'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AdminPostIdRouteImport } from './routes/admin.post.$id'
import { Route as AdminPillarSlugRouteImport } from './routes/admin.pillar.$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
            id: '/termos-de-uso',path: '/termos-de-uso',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const EquipeRoute = EquipeRouteImport.update({
            id: '/equipe',path: '/equipe',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AdminPostIdRoute = AdminPostIdRouteImport.update({
            id: '/admin/post/$id',path: '/admin/post/$id',getParentRoute: () => rootRouteImport
          })
const AdminPillarSlugRoute = AdminPillarSlugRouteImport.update({
            id: '/admin/pillar/$slug',path: '/admin/pillar/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRoute,ContatoRoute: ContatoRoute,EquipeRoute: EquipeRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,SobreRoute: SobreRoute,TermosDeUsoRoute: TermosDeUsoRoute,BlogSlugRoute: BlogSlugRoute,AdminIndexRoute: AdminIndexRoute,BlogIndexRoute: BlogIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,AdminPillarSlugRoute: AdminPillarSlugRoute,AdminPostIdRoute: AdminPostIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)